import AddIcon from '@mui/icons-material/Add'
import { Button, MenuItem, TextField } from '@mui/material'

interface Option {
  id: string
  name: string
}

interface Props {
  label: string
  labelCreate?: string
  options: Option[]
  value?: string
  error?: boolean
  helperText?: string
  onChange: (id: string) => void
  onCreate: () => void
}

export function SelectWithCreate({
  label,
  options,
  value,
  error,
  helperText,
  labelCreate = 'Criar',
  onChange,
  onCreate,
}: Props) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <TextField
        select
        fullWidth
        size="small"
        label={label}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        helperText={helperText}
      >
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.name}
          </MenuItem>
        ))}
      </TextField>

      <Button
        size="small"
        variant="outlined"
        onClick={onCreate}
        startIcon={<AddIcon />}
        sx={{
          whiteSpace: 'nowrap',
          textTransform: 'none',
          borderRadius: '10px',
          px: 2,
        }}
      >
        {labelCreate}
      </Button>
    </div>
  )
}
